<template>
  <div class="level-left">
    <h1 class="level-item is-size-3 has-text-weight-medium">devfinder</h1>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
